// src/pages/Contact.js
import React, { useMemo, useState, useEffect } from "react";
import "./styles/contact.css";

import { useDispatch, useSelector } from "react-redux";
import { createQuery } from "../app/features/contact/contactSlice"; // ✅ adjust path if yours differs

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";

const Contact = () => {
  const dispatch = useDispatch();

  // ✅ assuming slice key is: state.contact (change if different)
  const { isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.contact
  );

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  // ✅ Updated with your new details
  const info = useMemo(
    () => ({
      addressTitle: "Address",
      addressLines: ["P.O Box 9696", "Nasser Road, Light Arcade", "Room no. B14"],
      contactTitle: "Contact",
      contactLines: ["Phone: +256 200 949 142", "Email: kupto2020@gmail.com"],
      hoursTitle: "Open Time",
      hoursLines: ["Monday - Saturday : 8:00 AM - 7:00 AM"],
    }),
    []
  );

  // ✅ clear form on success
  useEffect(() => {
    if (isSuccess) {
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    }
  }, [isSuccess]);

  const onChange = (key) => (e) =>
    setForm((p) => ({ ...p, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: `${form.firstName} ${form.lastName}`.trim(),
      email: form.email.trim(),
      mobile: form.phone.trim(),
      subject: form.subject.trim(),
      comment: form.message.trim(),
    };

    dispatch(createQuery(payload));
  };

  return (
    <div className="ku-contact-page">
      {/* HERO */}
      <section className="ku-contact-hero">
        <h1 className="ku-contact-heroTitle">Contact Us</h1>
        <p className="ku-contact-bread">
          Home <span>/</span> Contact Us
        </p>
      </section>

      {/* CONTENT */}
      <section className="ku-contact-shell">
        <div className="ku-contact-top">
          <h2 className="ku-contact-headline">
            Have a Project Idea? <span>Let&apos;s Talk!</span>
          </h2>
        </div>

        <div className="ku-contact-grid">
          {/* LEFT: FORM */}
          <form className="ku-contact-form" onSubmit={onSubmit}>
            <div className="ku-contact-row2">
              <div className="ku-fields">
                <label className="ku-label">First Name *</label>
                <input
                  className="ku-input"
                  value={form.firstName}
                  onChange={onChange("firstName")}
                  placeholder="Ex. John"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="ku-fields">
                <label className="ku-label">Last Name *</label>
                <input
                  className="ku-input"
                  value={form.lastName}
                  onChange={onChange("lastName")}
                  placeholder="Ex. Doe"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="ku-contact-row2">
              <div className="ku-fields">
                <label className="ku-label">Email *</label>
                <input
                  className="ku-input"
                  type="email"
                  value={form.email}
                  onChange={onChange("email")}
                  placeholder="example@gmail.com"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="ku-fields">
                <label className="ku-label">Phone Number *</label>
                <input
                  className="ku-input"
                  value={form.phone}
                  onChange={onChange("phone")}
                  placeholder="Enter Phone Number"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="ku-fields">
              <label className="ku-label">Subject *</label>
              <input
                className="ku-input"
                value={form.subject}
                onChange={onChange("subject")}
                placeholder="Enter subject here..."
                required
                disabled={isLoading}
              />
            </div>

            <div className="ku-fields">
              <label className="ku-label">Your Message *</label>
              <textarea
                className="ku-textarea"
                value={form.message}
                onChange={onChange("message")}
                placeholder="Enter here..."
                rows={6}
                required
                disabled={isLoading}
              />
            </div>

            {/* ✅ inline status */}
            {isLoading && (
              <p className="ku-formStatus ku-formStatus--loading">
                Sending...
              </p>
            )}
            {isError && (
              <p className="ku-formStatus ku-formStatus--error">
                {message || "Something went wrong!"}
              </p>
            )}
            {isSuccess && (
              <p className="ku-formStatus ku-formStatus--success">
                Message sent successfully!
              </p>
            )}

            <button className="ku-sendBtn" type="submit" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </form>

          {/* RIGHT: INFO CARD */}
          <aside className="ku-contact-card">
            <div className="ku-cardBlock">
              <h3 className="ku-cardTitle">
                <FaMapMarkerAlt className="ku-cardIcon" />
                {info.addressTitle}
              </h3>
              <div className="ku-cardText">
                {info.addressLines.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}
              </div>
            </div>

            <div className="ku-cardDivider" />

            <div className="ku-cardBlock">
              <h3 className="ku-cardTitle">
                <FaPhoneAlt className="ku-cardIcon" />
                {info.contactTitle}
              </h3>
              <div className="ku-cardText">
                {info.contactLines.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}
              </div>

              <div className="ku-cardMiniRow">
                <FaEnvelope className="ku-miniIcon" />
                <span>Fast response within business hours</span>
              </div>
            </div>

            <div className="ku-cardDivider" />

            <div className="ku-cardBlock">
              <h3 className="ku-cardTitle">
                <FaClock className="ku-cardIcon" />
                {info.hoursTitle}
              </h3>
              <div className="ku-cardText">
                {info.hoursLines.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}
              </div>
            </div>

            <div className="ku-cardDivider" />

            <div className="ku-cardBlock">
              <h3 className="ku-cardTitle">Stay Connected</h3>
              <div className="ku-social">
                <button type="button" className="ku-socialBtn" aria-label="Facebook">
                  <FaFacebookF />
                </button>
                <button type="button" className="ku-socialBtn" aria-label="Twitter">
                  <FaTwitter />
                </button>
                <button type="button" className="ku-socialBtn" aria-label="Instagram">
                  <FaInstagram />
                </button>
                <button type="button" className="ku-socialBtn" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </button>
              </div>
            </div>
          </aside>
        </div>

        {/* MAP */}
        <div className="ku-mapWrap">
          <div className="ku-mapPin" aria-hidden="true">
            <span />
          </div>

          <iframe
            title="Map"
            className="ku-map"
            src="https://www.openstreetmap.org/export/embed.html?bbox=32.56%2C0.30%2C32.66%2C0.36&layer=mapnik"
          />
        </div>
      </section>
    </div>
  );
};

export default Contact;
